// Общая длительность вращения
export const SPIN_TOTAL_MS = 6000;

// Доля времени (0..1), после которой начинается замедление
export const DECELERATE_AT = 0.5;

// Минимальная длительность каждой фазы
export const MIN_PHASE_MS = 300;

// Сколько оборотов ИТОГО хотим пройти до полной остановки
export const TOTAL_TURNS = 8;

// Сколько оборотов проходим в БЫСТРОЙ фазе (первая половина времени)
export const FAST_TURNS = 6;
